export const USERNAME_BADGE_CLASS = "usernameBadge";
export const USERNAME_BADGE_VERIFIED_CLASS = "usernameBadgeVerified";
export const USERNAME_BADGE_SUPPORTER_CLASS = "usernameBadgeSupporter";

export const USERNAME_BADGE_VERIFIED_LABEL = "Minecraft linked";
export const USERNAME_BADGE_SUPPORTER_LABEL = "Supporter";
export const USERNAME_BADGE_SUPPORTER_COLOR = "#d4a017";

export function normalizeUsernameBadges(input) {
  if (!input || typeof input !== "object") {
    return { verified: false, supporter: false };
  }
  return {
    verified: Boolean(input.verified),
    supporter: Boolean(input.supporter),
  };
}

export function badgesFromPlayer(player) {
  if (!player) return { verified: false, supporter: false };
  const groups = Array.isArray(player.groups) ? player.groups : [];
  const secondary = Array.isArray(player.secondaryRoles) ? player.secondaryRoles : [];
  if (player.badges && typeof player.badges === "object") {
    const fromPayload = normalizeUsernameBadges(player.badges);
    return {
      verified:
        fromPayload.verified ||
        Boolean(player.minecraftUuid) ||
        groups.includes("minecraft-linked"),
      supporter:
        fromPayload.supporter ||
        player.role === "SUPPORTER" ||
        secondary.includes("SUPPORTER") ||
        groups.includes("supporter"),
    };
  }
  return {
    verified: Boolean(player.minecraftUuid) || groups.includes("minecraft-linked"),
    supporter:
      player.role === "SUPPORTER" ||
      secondary.includes("SUPPORTER") ||
      groups.includes("supporter"),
  };
}

export function badgesFromPayload(obj) {
  if (!obj || typeof obj !== "object") {
    return { verified: false, supporter: false };
  }
  if (obj.badges && typeof obj.badges === "object") {
    return normalizeUsernameBadges(obj.badges);
  }
  if (obj.verified != null || obj.supporter != null) {
    return {
      verified: Boolean(obj.verified),
      supporter: Boolean(obj.supporter),
    };
  }
  return {
    verified: Boolean(
      obj.minecraftUuid ||
        obj.authorMinecraftUuid ||
        obj.senderMinecraftUuid ||
        obj.playerMinecraftUuid ||
        obj.minecraftLinked
    ),
    supporter: false,
  };
}

export const usernameBadgeHtmlSx = {
  [`& .${USERNAME_BADGE_CLASS}`]: {
    display: "inline-flex",
    alignItems: "center",
    justifyContent: "center",
    ml: "0.2em",
    fontSize: "0.9em",
    lineHeight: 1,
    verticalAlign: "middle",
    fontWeight: 700,
  },
  [`& .${USERNAME_BADGE_VERIFIED_CLASS}`]: {
    color: "success.main",
  },
  [`& .${USERNAME_BADGE_SUPPORTER_CLASS}`]: {
    color: USERNAME_BADGE_SUPPORTER_COLOR,
  },
};

function createHtmlBadge(doc, kind) {
  const verified = kind === "verified";
  const span = doc.createElement("span");
  span.className = `${USERNAME_BADGE_CLASS} ${
    verified ? USERNAME_BADGE_VERIFIED_CLASS : USERNAME_BADGE_SUPPORTER_CLASS
  }`;
  const label = verified ? USERNAME_BADGE_VERIFIED_LABEL : USERNAME_BADGE_SUPPORTER_LABEL;
  span.setAttribute("aria-label", label);
  span.setAttribute("title", label);
  span.textContent = verified ? "✓" : "★";
  return span;
}

/** Append verified/supporter marks into `.userMention` chips. */
export function appendUsernameBadgesToMentionHtml(html, getMentionUser) {
  if (html == null || html === "") return html;
  if (typeof html !== "string" || !html.includes("userMention")) return html;
  if (typeof getMentionUser !== "function") return html;
  if (typeof DOMParser === "undefined") return html;

  const doc = new DOMParser().parseFromString(html, "text/html");
  const mentions = doc.querySelectorAll(".userMention[data-mention-username]");
  mentions.forEach((el) => {
    el.querySelectorAll(`.${USERNAME_BADGE_CLASS}`).forEach((node) => node.remove());
    const user = getMentionUser(el.dataset.mentionUsername);
    const badges = normalizeUsernameBadges(user?.badges);
    if (badges.verified) el.appendChild(createHtmlBadge(doc, "verified"));
    if (badges.supporter) el.appendChild(createHtmlBadge(doc, "supporter"));
  });
  return doc.body.innerHTML;
}
